// Which look this browser plays in. The classic look is the game screen from
// before the felt-table redesign, kept for players who prefer it. Both looks
// talk to the same server and the same game, so a player can switch mid-game.

const KEY = 'ui:classic';

export const prefersClassic = () => {
    try {
        return localStorage.getItem(KEY) === '1';
    } catch (error) {
        return false;
    }
};

export const setPrefersClassic = (classic) => {
    try {
        if (classic) {
            localStorage.setItem(KEY, '1');
        } else {
            localStorage.removeItem(KEY);
        }
    } catch (error) { /* private mode: the choice lasts for this page only */ }
};

/** The address of a game (or of the start screen) in either look. */
export const gamePath = (gameId, classic) => {
    const base = classic ? '/classic' : '';
    return gameId ? `${base}/${gameId}` : (base || '/');
};
